var defaultState = {
  waitTimerId: null,
  fbInit: false,
  googleAuth2: null
}

export const mutations = {
  setTimer (state, timerId) {
    state.waitTimerId = timerId
  },
  setFacebookInit (state) {
    state.fbInit = true
  },
  setGoogleInit (state, auth2) {
    state.googleAuth2 = auth2
  }
}

export const getters = {
  fbInitialized: state => state.fbInit,
  googleInitialized: state => !!state.googleAuth2,
  googleAuth2: state => state.googleAuth2
}

export const actions = {
  init ({ state, commit, dispatch, rootGetters }) {
    const timer = window.setInterval(() => {
      if (typeof window.gapi === 'undefined') return
      if (typeof window.FB === 'undefined') return

      window.clearInterval(state.waitTimerId)
      commit('setTimer', null)

      dispatch('initGoogle')
      dispatch('initFacebook')
    }, 200)

    commit('setTimer', timer)
  },

  logout ({ state }, disconnect) {
    if (state.fbInit) {
      try { window.FB.logout() } catch (e) {}
    }
    if (state.googleAuth2) {
      if (disconnect) state.googleAuth2.disconnect()
      state.googleAuth2.signOut()
    }
  },

  initGoogle ({ state, commit, rootGetters }) {
    if (state.googleAuth2) return

    window.gapi.load('auth2', () => {
      const auth2 = window.gapi.auth2.init({
        client_id: rootGetters['config/googleClientId'],
        cookiepolicy: 'single_host_origin'
      })

      console.log('[social] Google Auth API ready')
      commit('setGoogleInit', auth2)
    })
  },

  initFacebook ({ state, commit, rootGetters }) {
    if (state.fbInit) return

    window.FB.init({
      appId: rootGetters['config/facebookAppId'],
      autoLogAppEvents: true,
      xfbml: true,
      version: 'v3.1'
    })

    console.log('[social] Facebook Graph API ready')
    commit('setFacebookInit', true)
  }
}

export default {
  namespaced: true,
  state: defaultState,
  mutations: mutations,
  getters: getters,
  actions: actions
}



// WEBPACK FOOTER //
// ./src/store/modules/social.js